import { render, staticRenderFns } from "./penghapusan.vue?vue&type=template&id=60ed86ba&"
import script from "./penghapusan.vue?vue&type=script&lang=js&"
export * from "./penghapusan.vue?vue&type=script&lang=js&"
import style0 from "./penghapusan.vue?vue&type=style&index=0&id=60ed86ba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports